import { render, staticRenderFns } from "./AssignedUsersTable.vue?vue&type=template&id=125298df&"
import script from "./AssignedUsersTable.vue?vue&type=script&lang=js&"
export * from "./AssignedUsersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports